import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';
import { SemovelProvider } from '../../providers/semovel/semovel';
import { PedidoFormPage } from '../pedido-form/pedido-form';
import { PromocaoUtilProvider } from '../../providers/promocao-util/promocao-util';
import { ProdutoViewPage } from '../produto-view/produto-view';
import { DadosProvider } from '../../providers/dados/dados';
import { ProdutoListPage } from '../produto-list/produto-list';
import { ViewProvider } from '../../providers/view/view';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  logoLoja:string;

  produtos:Array<any>;

  grupos:Array<any>;
 
  promocoes:Array<any>;
  
  mais_pedidos:Array<any>;

  produtos_novos:Array<any>;
  
  banners:Array<any> = [];

  constructor(public navCtrl: NavController, public server:SemovelProvider, 
    private promocaoUtil:PromocaoUtilProvider, private eve:Events, 
    private dadosP:DadosProvider, private view:ViewProvider) {
    this.produtos = [];
    this.grupos = [];
    this.promocoes = [];
    this.mais_pedidos = [];
    this.produtos_novos = [];
    this.eve.subscribe("home:abrirGrupo", (grupo) => {
      this.abrirProdutosPorGrupo(grupo);
    });
  }
  
  ionViewDidLoad() {
    this.logoLoja = "assets/imgs/logo_loja.png";

    const request = { method: 'home/list' };

    this.server.postData(request).subscribe(data => {
      if (data){
        this.carregarDados(data);
      }
       
      return true;
    },
    error => { 
      this.server.showError(error); 
    }          
    );
  }
  
  ionViewDidEnter(){    
    this.logoLoja = "assets/imgs/logo_loja.png";
  }

  carregarDados(dados){
    console.log(dados);
    
    this.promocoes = dados.promocoes;
    this.mais_pedidos = dados.maisPedidos;
    this.produtos_novos = dados.produtosNovos;
    this.grupos = dados.categorias;
    this.banners = dados.banners;

    this.dadosP.salvarConfiguracao(dados.configuracao) ;
    
    this.dadosP.faleNutri = dados.faleNutri ;

    this.dadosP.permitirDuvida = dados.permitirDuvida ;

    this.eve.publish("home:grupos", this.grupos);

    if(dados.banners){
      console.log(dados.banners);
      this.banners = dados.banners;
    }

    if(dados.alerta){
      this.server.showMessage(dados.alerta);
    }
  }

  realizarPedido(){
    this.navCtrl.push(PedidoFormPage, {});
  }

  ver_produto(promocao){
    this.promocaoUtil.verProduto(promocao);
  }

  visualizarProduto(produto){
    this.navCtrl.push(ProdutoViewPage, {
      produto: produto
    });
  }

  adicionarCarrinho(produto, unidade){
    this.eve.publish("carrinho:adicionar", produto, unidade);
  }

  abrirProdutosPorGrupo(grupo){
    this.navCtrl.setRoot(ProdutoListPage, {
      grupo: grupo
    });
  }

  abrirBanner(banner){
    if(banner.tipo == 0) return;

    if(banner.tipo == 1 && banner.produto)
      this.visualizarProduto(banner.produto);
    else if(banner.linkExterno)
      this.view.abrirLink(banner.linkExterno);
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts